import React, { useState, useEffect } from 'react';

import FileUpload from '../../../../components/FileUpload/FileUploader';
import dictionarystreet from '../data/addresses.json';
import AddressFull from './Autocomplete/AddressFull';
import DateSplit from '../widgets/date';
import CertificateSplit from '../widgets/certificate/CertificateSplit';
import RadioWidgetPlain from './RadioWidget/radiowidget';
import { loadFileAsBase64 } from '../../../../services/apiClient';

const curDate = new Date();
const curYear = curDate.getFullYear();

const handleFileViewRequest = async (id, fileId, fileIndex) => {
  const url = `requests/${id}/file/${fileId}/cert`;
  try {
    const response = await loadFileAsBase64(url);
    return response; 
  } catch (error) {
    console.error('Ошибка загрузки файла:', error);
    throw error;
  }
};

const Step1 = ({ formData, errors, onChange, isEdit=false, isAccept = false }) => {
  // Визначаємо, чи потрібно показувати текстове поле для адреси
  const showTextAddress = formData.child.isAddressKyiv === "no" || 
                          (formData.child.isAddressKyiv === "yes" && formData.child.notFindKyivAddress === true);

  // Стан для країни (для відстеження змін)
  const [country, setCountry] = useState(formData.child.birthCertificate?.country || "ua");

  // Обробник зміни країни
  const handleCountryChange = (value) => {
    setCountry(value);
    onChange('child.birthCertificate.country', value);
    
    // Якщо переключили на Україну і значення порожнє - встановлюємо значення за замовчуванням
    if (value === 'ua') {
      const currentValue = formData.child.birthCertificate?.seriesNumber;
      if (!currentValue) {
        onChange('child.birthCertificate.seriesNumber', 'І-БК ');
      }
    }
  };

  const isDisable = (!isAccept && !!formData?._id);

  const disabledObj = ["cert", "name", "birthdate"];

  return (
    <div className="form-section">
      <h2 className="form-section-title">Дані дитини</h2>
      
      <div className="form-row-plain single">
        <div className="form-group">
          <label className="form-label">Прізвище дитини</label>
          <input
            type="text"
            className={`form-control ${errors.childLastName ? 'is-invalid' : ''}`}
            placeholder=""
            value={formData.child.lastName}
            onChange={(e) => onChange('child.lastName', e.target.value)}
          />
          {errors.childLastName && <div className="invalid-feedback">{errors.childLastName}</div>}
        </div>
      </div>
      
      <div className="form-row-plain two-cols">
        <div className="form-group">
          <label className="form-label">Ім'я дитини</label>
          <input
            type="text"
            className={`form-control ${errors.childFirstName ? 'is-invalid' : ''}`}
            placeholder=""
            value={formData.child.firstName}
            onChange={(e) => onChange('child.firstName', e.target.value)}
          />
          {errors.childFirstName && <div className="invalid-feedback">{errors.childGender}</div>}
        </div>
        <div className="form-group">
          <label className="form-label">По батькові дитини (залиште пустим, якщо немає)</label>
          <input
            type="text"
            className="form-control"
            placeholder=""
            value={formData.child.secondName}
            onChange={(e) => onChange('child.secondName', e.target.value)}
          />
        </div>
      </div>

      <DateSplit 
        id={'r-formData.child.birthdate'} 
        error={errors.childBirthDate} 
        date={formData.child.birthDate} 
        setDate={(v)=>onChange('child.birthDate', v)} 
        yearFrom={2017}  
        yearTo={curYear} 
        label="Дата народження"
        readOnly={disabledObj.includes("birthdate") && isDisable} 
      />

      <RadioWidgetPlain 
        id={'r-formData.child.gender'} 
        value={formData.child.gender} 
        variants={["girl","boy"]} 
        labels={["Дівчинка","Хлопчик"]} 
        title='Стать дитини' 
        onChange={(d)=>onChange('child.gender', d)}
        isError={!!errors.childGender} 
      />
      {errors.childGender && <div className="invalid-feedback">{errors.childGender}</div>}
     
      <hr className="section-divider" />

      <h2 className="form-section-title">Адреса проживання дитини</h2>

      <RadioWidgetPlain 
        id={'r-formData.child.isAddressKyiv'} 
        value={formData.child.isAddressKyiv}  
        title='Дитина проживає в Києві?' 
        onChange={(d)=>{
          onChange('child.isAddressKyiv', d);
          if (d === "no") {
            onChange('child.notFindKyivAddress', false);
          }
        }} 
      />

      {formData.child.isAddressKyiv === "yes" && (
        <div className="form-group">
          <div className="form-check mt-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="not-find-kyiv-address"
              checked={formData.child.notFindKyivAddress === true}
              onChange={(e) => {
                onChange('child.notFindKyivAddress', e.target.checked);
                if (e.target.checked) {
                  onChange('child.addressYur', { district: '', street: '', building: '', corpus: '' });
                }
              }}
            />
            <label className="form-check-label" htmlFor="not-find-kyiv-address">
              Адреса в Києві, але відсутня в довіднику
            </label>
          </div>
        </div>
      )}

      {formData.child.isAddressKyiv === "yes" && formData.child.notFindKyivAddress !== true && (
        <AddressFull 
          dictionary={formData.dictionary}  
          title='Зареєстроване місце проживання' 
          value={formData.child.addressYur || {}} 
          fieldsPath='child.addressYur' 
          onChange={onChange} 
          error={errors.childaddress} 
        />
      )}

      {showTextAddress && (
        <div className="form-group">
          <label className="form-label">
            {formData.child.isAddressKyiv === "yes" 
              ? "Введіть адресу в Києві (відсутня в довіднику)" 
              : "Введіть повну адресу"}
          </label>
          <input
            type="text"
            className={`form-control ${errors.childaddress ? 'is-invalid' : ''}`}
            placeholder=""
            value={formData.child.address}
            onChange={(e) => onChange('child.address', e.target.value)}
          />
          {errors.childaddress && <div className="invalid-feedback">{errors.childaddress}</div>}
        </div>
      )}

      <RadioWidgetPlain 
        id={'r-formData.child.sameFactAddress'} 
        value={formData.child.sameFactAddress}  
        title='Фактичне місце проживання дитини відповідає зареєстрованому місцю проживання?' 
        onChange={(d)=>onChange('child.sameFactAddress', d)}
        isError={!!errors.childSameFactAddress} 
      />
      {errors.childSameFactAddress && <div className="invalid-feedback">{errors.childSameFactAddress}</div>}
      
      {formData.child.sameFactAddress === "no" && formData.child.isAddressKyiv === "yes" && formData.child.notFindKyivAddress !== true && (
        <AddressFull 
          dictionary={formData.dictionary}  
          title='Фактичне місце проживання' 
          value={formData.child.addressFact || {}} 
          fieldsPath='child.addressFact' 
          onChange={onChange} 
          error={errors.childaddressFact} 
        />
      )}

      {formData.child.sameFactAddress === "no" && showTextAddress && (
        <div className="form-group">
          <label className="form-label">
            {formData.child.isAddressKyiv === "yes" 
              ? "Фактичне місце проживання в Києві (відсутня в довіднику)" 
              : "Фактичне місце проживання"}
          </label>
          <input
            type="text"
            className={`form-control ${errors.childaddressFact ? 'is-invalid' : ''}`}
            placeholder=""
            value={formData.child.addressFactStr}
            onChange={(e) => onChange('child.addressFactStr', e.target.value)}
          />
          {errors.childaddressFact && <div className="invalid-feedback">{errors.childaddressFact}</div>}
        </div>
      )}
      
      <h2 className="form-section-title">Дані свідоцтва про народження</h2>
      
      <RadioWidgetPlain 
        id={'r-formData.child.birthCertificate.country'} 
        value={country} 
        variants={["ua", "other"]} 
        labels={["Україна", "Іноземна держава"]} 
        title='Країна, що видала свідоцтво' 
        onChange={handleCountryChange}
        readOnly={disabledObj.includes("cert") && isDisable}
      />

      {/* Для України - використовуємо CertificateSplit */}
      {country === "ua" ? (
        <CertificateSplit
          id="birth-certificate"
          label="Серія та номер свідоцтва *"
          value={formData.child.birthCertificate?.seriesNumber || "І-БК "}
          setValue={(v) => onChange('child.birthCertificate.seriesNumber', v)}
          error={errors.childCertificate}
          readOnly={disabledObj.includes("cert") && isDisable}
        />
      ) : (
        /* Для іноземних свідоцтв - звичайне текстове поле */
        <div className="form-row-plain single">
          <div className="form-group">
            <label className="form-label">Серія та номер</label>
            <input
              type="text"
              className={`form-control ${errors.childCertificate ? 'is-invalid' : ''}`}
              placeholder=""
              value={formData.child.birthCertificate?.seriesNumber || ''}
              onChange={(e) => onChange('child.birthCertificate.seriesNumber', e.target.value)}
              style={isDisable ? { backgroundColor: 'rgb(244, 247, 249)'}:{}}
              disabled={disabledObj.includes("cert") && isDisable}
            />
            {errors.childCertificate && <div className="invalid-feedback">{errors.childCertificate}</div>}
          </div>
        </div>
      )}
      
      <DateSplit 
        id={'r-formData.child.issuedate'}  
        error={errors.childCertificateDate} 
        date={formData.child.birthCertificate?.issueDate} 
        setDate={(v)=>onChange('child.birthCertificate.issueDate', v)} 
        yearFrom={2017}  
        yearTo={curYear} 
        label="Дата видачі свідоцтва"
        readOnly={disabledObj.includes("cert") && isDisable} 
      />
      
      <FileUpload
        label='Завантажте фото чи скан-копію документа'  
        value={formData.child.birthCertificate?.files} 
        onChange={(files)=>onChange('child.birthCertificate.files', files)} 
        onBlur={(files)=>onChange('child.birthCertificate.files', files)} 
        onFocus={(files)=>onChange('child.birthCertificate.files', files)}
        multiple={true}
        errorVal={errors.childCertificateScan}
        description='Один або кілька файлів у форматі PDF, JPG, PNG. Максимальний розмір файлу 5 МБ.'
        maxSize={5 * 1024 * 1024}
        onFileViewRequest={(fileId, fileIndex)=>handleFileViewRequest(formData._id, fileId, fileIndex)}
      />
    </div>
  );
};

export default Step1;